import { useQuery } from '@tanstack/react-query'
import { overviewApi } from '@/api/endpoints/overview'

export function useOverview() {
  return useQuery({
    queryKey: ['overview'],
    queryFn: () => overviewApi.getOverview(),
    refetchInterval: 30000, // Refresh every 30 seconds
  })
}
